import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';

import { TelaInicialComponent } from './components/tela-inicial.component';

@NgModule({
  declarations: [
    TelaInicialComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
  ],
})
export class TelaInicialModule { }
